import React,{useState,useEffect} from 'react'
import './TermsTimer.scss'

const TermsTimer = ({child}) => {

    const [timer,setTimer] = useState(0)
    const tick = () => {
        setTimer(prevTimer => prevTimer+1)
    }
    useEffect(() => {
        const interval = setInterval(tick,1000)
        return () => {
            clearInterval(interval)
        }
    }, [timer])

    const formatTime = () => {
        const getSeconds = `0${(timer % 60)}`.slice(-2)
        const minutes = `${Math.floor(timer / 60)}`
        const getMinutes = `0${minutes % 60}`.slice(-2)
        const getHours = `0${Math.floor(timer / 3600)}`.slice(-2)
    
        return `${getHours} : ${getMinutes} : ${getSeconds}`
    }
    return (
        <>
            <p className="time1">{formatTime()}</p>
            <p className="time2">Finding Match</p>
        </>
    )
}

export default TermsTimer
